import React from 'react';
import {Map} from 'immutable';
import {percent} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  CART_STATES,
  NODE_TYPE_COMMERCE_CART_FORM,
} from '@packages/systems/commerce/constants';
import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';
import {getCommerceDataProperty} from './ContextUtils';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';
import {UserItem} from './utils/OrderItemsUtils';

const styleDisplayNone = Map({style: Map({display: 'none'})});

const getUserItems = getCommerceDataProperty('userItems', []);

const shouldThisComponentBeShown = ({
  runtimeEnvironment,
  tempState,
  userItems,
}: {
  runtimeEnvironment: Environment;
  tempState: unknown;
  userItems: UserItem[];
}) => {
  const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

  if (isDesigner) {
    return tempState === CART_STATES.DEFAULT || tempState === CART_STATES.ERROR;
  }
  return Boolean(userItems && userItems.length > 0);
};

const CommerceCartForm = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;

  const runtimeEnvironment = useRuntimeEnvironment();
  const tempState = context.get('tempState');
  const userItems = getUserItems(context);

  const styledAttributes = shouldThisComponentBeShown({
    runtimeEnvironment,
    tempState,
    userItems,
  })
    ? attributes
    : attributes.merge(styleDisplayNone);
  return (
    <form
      {...generateAttributes(styledAttributes, classes)}
      data-node-type={NODE_TYPE_COMMERCE_CART_FORM}
    >
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </form>
  );
});

const config = createIntegratedAtom({
  displayName: 'Default State',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [{is: 'CommerceCartList', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: percent(0),
        },
      },
    },
  },
  render: CommerceCartForm,
  fields: {
    children: TListOfElement,
  },
});

export default config;
